import React, { useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import cookie from "react-cookies";
import { CLIQ_BASE_URL, UNIFIED_BASE_URL, WEB_BASE_URL } from "../../webbase";

const KYCModal = ({ show, onHide, onSubmit, title, emailAddress, id }) => {
    const [status, setStatus] = useState("");
    const [subDomainUrl, setSubDomainUrl] = useState("");
    const [token, setToken] = useState(cookie.load("token"));

    const handleSubmit = (e) => {
        e.preventDefault();
        const id = toast.loading("Processing KYC request...");
        
        // Prepare request data based on status
        const requestData = {
            emailAddress: emailAddress,
            status: status,
            ...(status === "approve" && { subDomainUrl: subDomainUrl }) // Only include subDomainUrl if status is approve
        };

        axios.post(UNIFIED_BASE_URL + "/onboarding/update-kyc-status", requestData, {
            headers: {
                "Content-Type": "application/json",
                Authorization: token,
            },
        })
        .then((res) => {
            if (res.data.status === "2000") {
                toast.update(id, {
                    render: `Successfully ${status === "approve" ? "Approved" : "Rejected"} KYC Request`,
                    type: "success",
                    isLoading: false,
                });
                // Reset form
                window.location.reload();
            } else {
                toast.update(id, {
                    render: res.data.description || "Error processing KYC request",
                    type: "error",
                    isLoading: false,
                });
            }
        })
        .catch((err) => {
            console.log(err);
            toast.update(id, {
                render: err.response?.data?.description || "Error processing KYC request",
                type: "error",
                isLoading: false,
            });
        })
        .finally(() => {
            setTimeout(() => {
                toast.dismiss();
            }, 2000);
        });
    };

    return (
        <div
            className="modal fade"
            id={id}
            tabIndex="-1"
            aria-labelledby="exampleModalLabel"
            aria-hidden="true"
        >
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="exampleModalLabel">
                            {title}
                        </h5>
                        <button
                            type="button"
                            className="btn-close"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                        ></button>
                    </div>
                    <div className="modal-body">
                        <form onSubmit={handleSubmit} className="row g-3">
                            <div className="col-12">
                                <label className="form-label">Email Address</label>
                                <input
                                    type="email"
                                    className="form-control"
                                    value={emailAddress}
                                    disabled
                                    readOnly
                                />
                            </div>
                            <div className="col-12">
                                <label className="form-label">Status</label>
                                <select
                                    className="form-select"
                                    value={status}
                                    onChange={(e) => {
                                        setStatus(e.target.value);
                                        if (e.target.value === "reject") {
                                            setSubDomainUrl(""); // Clear subDomainUrl when rejecting
                                        }
                                    }}
                                    required
                                >
                                    <option value="">Select Status</option>
                                    <option value="approve">Approve</option>
                                    <option value="reject">Reject</option>
                                </select>
                            </div>
                            {status === "approve" && (
                                <div className="col-12">
                                    <label className="form-label">Sub Domain URL</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={subDomainUrl}
                                        onChange={(e) => setSubDomainUrl(e.target.value)}
                                        placeholder="Enter sub domain URL"
                                        required
                                    />
                                </div>
                            )}
                        </form>
                    </div>
                    <div className="modal-footer">
                        <button
                            type="button"
                            className="btn btn-secondary"
                            data-bs-dismiss="modal"
                        >
                            Cancel
                        </button>
                        <button
                            type="button"
                            className="btn btn-primary"
                            onClick={handleSubmit}
                        >
                            Submit
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default KYCModal; 